/**
 * Forwarding API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface AddPeppolIntegrationDTO { 
    primaryPeppolIdScheme?: string;
    primaryPeppolIdValue?: string;
    secondaryPeppolIdScheme?: string;
    secondaryPeppolIdValue?: string;
    companyName?: string;
    countryCode?: string;
    city?: string;
    addressLine1?: string;
    zipCode?: string;
    exchangeCapability?: AddPeppolIntegrationDTO.ExchangeCapabilityEnum;
}
export namespace AddPeppolIntegrationDTO {
    export type ExchangeCapabilityEnum = 0 | 1 | 2;
    export const ExchangeCapabilityEnum = {
        NUMBER_0: 0 as ExchangeCapabilityEnum,
        NUMBER_1: 1 as ExchangeCapabilityEnum,
        NUMBER_2: 2 as ExchangeCapabilityEnum
    };
}